import "alpinejs";
import Swiper from "swiper";
import GLightbox from "glightbox"

var mySwiper = new Swiper(".swiper-container", {
  pagination: {
    el: ".swiper-pagination",
    type: "bullets",
    bulletClass: "swiper-bullet",
    bulletActiveClass: "bg-buttercup",
    clickable: true,
    renderBullet: function(index, className) {
      return (
        '<span class="block w-4 h-4 mx-2 bg-transparent border border-buttercup index-' +
        index +
        " " +
        className +
        '"></span>'
      );
    },
  },
});

const glightbox = document.getElementsByClassName("glightbox");
if (glightbox.length) {
  var lightbox = GLightbox(); 
}